import { Braces, FlaskConical, GitBranch, Globe2, Map, Menu, Network, PanelTop, X } from "lucide-react";
import { useState, type ReactNode } from "react";
import { NavLink } from "react-router-dom";

const navigation = [
  { to: "/graph", label: "Graph", icon: Network },
  { to: "/learn", label: "Learn", icon: Map },
  { to: "/build", label: "Build", icon: Braces },
  { to: "/lab", label: "Lab", icon: FlaskConical },
  { to: "/evidence", label: "Evidence", icon: GitBranch },
  { to: "/system", label: "System", icon: PanelTop },
  { to: "/web-platform", label: "Platform", icon: Globe2 },
];

export function AppShell({ children }: { children: ReactNode }) {
  const [open, setOpen] = useState(false);
  return (
    <div className="app-shell">
      <a className="skip-link" href="#main-content">Skip to content</a>
      <header className="site-header">
        <NavLink className="brand" to="/" aria-label="PWEB home">
          <span>P</span>WEB <small>LEARNING + WEBSITE PLATFORM</small>
        </NavLink>
        <button className="icon-button mobile-menu" onClick={() => setOpen(!open)} aria-expanded={open} aria-label="Toggle navigation">
          {open ? <X aria-hidden="true" /> : <Menu aria-hidden="true" />}
        </button>
        <nav className={open ? "primary-nav is-open" : "primary-nav"} aria-label="Primary navigation">
          {navigation.map(({ to, label, icon: Icon }) => (
            <NavLink key={to} to={to} onClick={() => setOpen(false)}>
              <Icon size={15} aria-hidden="true" /><span>{label}</span>
            </NavLink>
          ))}
        </nav>
        <span className="build-stamp">V1 / LIVE SYSTEM</span>
      </header>
      <main id="main-content">{children}</main>
      <footer className="site-footer">
        <span>PWEB / PENGYI WEB LAYER</span>
        <NavLink to="/changelog">Changelog</NavLink>
        <a href="https://github.com/pengpengyi92/PWEB" target="_blank" rel="noreferrer">Source</a>
        <span>2026</span>
      </footer>
    </div>
  );
}
